import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import CSatSurveyModal from '../components/CSatSurveyModal';

const BASE = 'https://www.seotechexperts.in/testserver/tes/wp-content/uploads/2026';

const SECTORS = [
  {
    id: 'it',
    title: 'Data Centres',
    blurb: 'HV/LV panel installations, CSS coupling, capacitor panels and fire-safety drills for hyperscale data centre operators.',
    logos: [
      '/clients/logo-31.webp',
      '/clients/logo-23.webp',
      '/clients/logo-21.webp',
      '/clients/logo-8.webp',
      '/clients/amazon.png',
      '/clients/mastercard.png',
      '/clients/microsoft.png',
      '/clients/wipro.png',
    ],
    photos: [
      { src: `${BASE}/02/LV-Panel-CSS-Coupling.jpeg`, caption: 'LV Panel + CSS Coupling' },
      { src: `${BASE}/02/LV-Panel-Installation.jpeg`, caption: 'LV Panel Installation' },
      { src: `${BASE}/03/Fire-mock-drill-at-Ctrls-Mumbai-it-detacnter.png`, caption: 'Fire Mock Drill — Ctrls Mumbai' },
      { src: `${BASE}/02/CSS-LV-Panel-Coupled.jpeg`, caption: 'CSS + LV Panel Coupled' },
      { src: `${BASE}/02/CSS-LV-Panel-coupling.jpeg`, caption: 'CSS + LV Panel Coupling' },
      { src: `${BASE}/02/HV-Panel-capacitor-panel.jpeg`, caption: 'HV Panel + Capacitor Panel' },
      { src: `${BASE}/02/HV-Panel-2.webp`, caption: 'HV Panel' },
      { src: `${BASE}/02/HV-Panel-charged.webp`, caption: 'HV Panel Charged' },
    ],
  },
  {
    id: 'automobile',
    title: 'Automobile Industry',
    blurb: 'EHV/HV substation works, LV panels and BBT installations for India\'s leading auto-component manufacturers and OEMs.',
    logos: [
      '/clients/logo-30.webp',
      '/clients/logo-28.webp',
      '/clients/logo-29.webp',
      '/clients/napino.png',
      '/clients/logo-27.webp',
      '/clients/logo-7.webp',
      '/clients/logo-2.webp',
      '/clients/maruti-suzuki.png',
      '/clients/sandhar.png',
    ],
    photos: [
      { src: `${BASE}/02/Power-BBT-installation-1.jpeg`, caption: 'Power BBT Installation' },
      { src: `${BASE}/02/Power-BBT-installation-2.jpeg`, caption: 'Power BBT Installation' },
      { src: `${BASE}/02/LV-Panel-1.jpeg`, caption: 'LV Panel' },
      { src: `${BASE}/02/Napino-1.jpg`, caption: 'Napino' },
      { src: `${BASE}/02/Napino-2.jpg`, caption: 'Napino' },
      { src: `${BASE}/02/Napino-4.jpg`, caption: 'Napino' },
    ],
  },
  {
    id: 'food',
    title: 'Food & Beverages',
    blurb: 'Power BBT installations, HV/LV panels and energy systems for large-scale food processing and beverage manufacturers.',
    logos: [
      '/clients/logo-26.webp',
      '/clients/logo-24.webp',
      '/clients/logo-3.webp',
      '/clients/logo-22.webp',
    ],
    photos: [
      { src: `${BASE}/02/Bikanervala-Factory-1.jpeg`, caption: 'Bikanervala Factory' },
      { src: `${BASE}/02/Bikanervala-Factory-2.jpeg`, caption: 'Bikanervala Factory' },
      { src: `${BASE}/02/Power-BBT-installation-1-1.jpeg`, caption: 'Power BBT Installation' },
    ],
  },
  {
    id: 'hospitality',
    title: 'Hospitality Sector',
    blurb: 'Total electrical EPC for five-star hotels, resort properties and integrated hospitality estates.',
    logos: [
      '/clients/logo-12.webp',
      '/clients/logo-11.webp',
      '/clients/logo-32.webp',
      '/clients/marriott.png',
    ],
    photos: [
      { src: `${BASE}/02/1.png`, caption: 'Hospitality Project' },
      { src: `${BASE}/02/2.png`, caption: 'Hospitality Project' },
    ],
  },
  {
    id: 'infra',
    title: 'Infra Projects',
    blurb: 'Switchyards, stadium lighting, transmission lines and high-side works for metro rail, education and infra clients.',
    logos: [
      '/clients/dmrc.webp',
      '/clients/mrvc.webp',
      '/clients/shivnadar.webp',
      '/clients/toshiba.webp',
      '/clients/uttam-industrial.png',
    ],
    photos: [
      { src: `${BASE}/03/Shiv-Nadar-Faridabad-infra-scaled.jpg`, caption: 'Shiv Nadar Faridabad' },
      { src: `${BASE}/03/Shiv-Nadar-site-Faridabad-infra-scaled.jpg`, caption: 'Shiv Nadar Site' },
      { src: `${BASE}/03/Uttam-Industrial-Engineering-Pvt.-Ltd.-Pandaria-Chattisgarh-infra.jpg`, caption: 'Uttam Industrial Engineering' },
      { src: `${BASE}/02/Stadium-lighting-at-Shiv-Nadar-Faridabad.webp`, caption: 'Stadium Lighting — Shiv Nadar' },
      { src: `${BASE}/02/Samsung.webp`, caption: 'Samsung' },
      { src: `${BASE}/02/6.jpeg`, caption: 'Infra Project' },
    ],
  },
  {
    id: 'other',
    title: 'Other Factories & Buildings',
    blurb: 'Feeder pillar panels, plant electricals and building high-side works across diverse industrial and commercial estates.',
    logos: [
      '/clients/logo-5.webp',
      '/clients/logo-16.webp',
      '/clients/logo-25.webp',
      '/clients/logo-15.webp',
      '/clients/logo-18.webp',
      '/clients/acegroup.png',
      '/clients/ireo.webp',
      '/clients/logo-10.webp',
      '/clients/logo-13.webp',
      '/clients/logo-20.webp',
      '/clients/logo-19.webp',
      '/clients/logo-6.webp',
      '/clients/avery-dennison.webp',
    ],
    photos: [
      { src: `${BASE}/02/4-1.jpeg`, caption: 'Factory Project' },
      { src: `${BASE}/03/Feeder-Panel-unload-Ace-Acreville-Yamuna-Express-way-other.png`, caption: 'Feeder Panel — Ace Acreville' },
      { src: `${BASE}/03/Feeder-Pillar-Panel-at-Ace-Acreville-YEW-other.jpeg`, caption: 'Feeder Pillar Panel — Ace Acreville YEW' },
      { src: `${BASE}/02/1.jpg`, caption: 'Building Project' },
      { src: `${BASE}/02/2.jpeg`, caption: 'Building Project' },
      { src: `${BASE}/02/3.png`, caption: 'Building Project' },
    ],
  },
];

function LogoCarousel({ logos, isDark }) {
  // TWO copies for a perfectly seamless -50% marquee loop (closed loop)
  const allLogos = [...logos, ...logos];
  const speed = Math.max(logos.length * 9, 42);

  return (
    <div className="relative overflow-hidden" data-testid="logo-carousel">
      {/* Fade edges */}
      <div className={`absolute left-0 top-0 bottom-0 w-28 z-10 pointer-events-none ${isDark ? 'bg-gradient-to-r from-[var(--ink)] to-transparent' : 'bg-gradient-to-r from-[var(--cream)] to-transparent'}`}/>
      <div className={`absolute right-0 top-0 bottom-0 w-28 z-10 pointer-events-none ${isDark ? 'bg-gradient-to-l from-[var(--ink)] to-transparent' : 'bg-gradient-to-l from-[var(--cream)] to-transparent'}`}/>
      <div
        className="flex gap-5"
        style={{ animation: `marquee ${speed}s linear infinite`, width: 'max-content' }}
      >
        {allLogos.map((src, j) => (
          <div
            key={j}
            className={`flex-shrink-0 h-[130px] w-[220px] rounded-2xl flex items-center justify-center p-3 border transition-all duration-300 hover:scale-105 ${
              isDark
                ? 'bg-white border-white/20 hover:border-[var(--orange)]/50 hover:shadow-lg'
                : 'bg-white border-[var(--line)] hover:border-[var(--orange)]/50 hover:shadow-lg'
            }`}
          >
            <img
              src={src}
              alt="Client"
              className="max-h-[110px] max-w-[195px] w-auto h-auto object-contain"
              loading="lazy"
              onError={(e) => { e.currentTarget.style.opacity = '0.15'; }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function OurWork() {
  const [heroLoaded, setHeroLoaded] = useState(false);
  const onHeroLoad = useCallback(() => setHeroLoaded(true), []);
  const [csatOpen, setCsatOpen] = useState(false);

  return (
    <main>
      {/* HERO — Extended scrollable hero with new image + shimmer */}
      <section
        className="relative overflow-hidden"
        style={{ height: '120svh', minHeight: '700px' }}
        data-testid="work-hero"
        data-nav-theme="dark"
      >
        <div className={`absolute inset-0 bg-[var(--ink)] transition-opacity duration-700 ${heroLoaded ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}><div className="absolute inset-0 shimmer-bg"/></div>
        <img
          src="/img/ourwork-hero.jpg"
          alt="Tricolite Energy — Silently Energizing Our Nation"
          className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-700 ${heroLoaded ? 'opacity-100' : 'opacity-0'}`}
          loading="eager"
          fetchPriority="high"
          onLoad={onHeroLoad}
        />
        <div className="absolute inset-0 bg-[var(--ink)]/55"/>
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--ink)]/90 from-25% via-[var(--ink)]/60 to-[var(--ink)]/20"/>
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/60 via-transparent to-[var(--ink)]/10"/>
        <div className="absolute inset-0 noise opacity-15 pointer-events-none"/>

        <div className="relative h-full px-6 md:px-10 lg:px-14 max-w-[1500px] mx-auto flex flex-col justify-center pt-[84px]">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/25 mb-6 reveal">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--orange)]"/>
              <span className="text-[11px] uppercase tracking-[0.3em] font-semibold text-white">Our Work</span>
            </div>
            <h1 className="font-display text-[clamp(40px,5.8vw,84px)] leading-[1.02] font-bold tracking-tight reveal" style={{ color: '#fff', transitionDelay: '120ms' }}>
              Silently Energizing<br/>
              <span className="font-serif-it text-[var(--orange)]">Our Nation.</span>
            </h1>
            <p className="mt-8 text-[17px] md:text-[19px] text-white/95 font-medium max-w-2xl leading-[1.75] reveal" style={{ transitionDelay: '280ms' }}>
              From the country's largest auto-OEMs and hyperscale data centres to metros, food processors and five-star hospitality estates — a portfolio built sector by sector.
            </p>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60">
          <div className="w-px h-12 bg-white/50 animate-pulse"/>
          <span className="text-[10px] uppercase tracking-[0.2em] text-white/70">Scroll</span>
        </div>
      </section>

      {/* Sector chip index */}
      <section className="px-6 md:px-10 lg:px-14 py-8 bg-[var(--cream)] border-b border-[var(--line)] sticky top-[84px] z-30 backdrop-blur-md bg-[var(--cream)]/85">
        <div className="max-w-[1500px] mx-auto flex flex-wrap gap-2" data-testid="sector-index">
          {SECTORS.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className="px-4 py-2 rounded-full border border-[var(--line)] bg-white text-[12.5px] tracking-wide text-[var(--ink)] hover:border-[var(--orange)] hover:text-[var(--orange)] transition-colors"
              data-testid={`sector-chip-${s.id}`}
            >
              {s.title}
            </a>
          ))}
        </div>
      </section>

      {/* Sector blocks */}
      {SECTORS.map((sector, idx) => {
        const isDark = idx % 2 === 1;
        return (
          <section
            key={sector.id}
            id={sector.id}
            className={`relative overflow-hidden px-6 md:px-10 lg:px-14 py-16 lg:py-24 ${isDark ? 'bg-[var(--ink)] text-white' : 'bg-[var(--cream)]'}`}
            data-testid={`sector-section-${sector.id}`}
            data-nav-theme={isDark ? 'dark' : undefined}
          >
            {isDark && <div className="absolute inset-0 grid-bg-dark opacity-25 pointer-events-none"/>}
            {!isDark && <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none"/>}
            {isDark && <div className="absolute -top-32 -right-32 w-[400px] h-[400px] rounded-full bg-[var(--orange)]/12 blur-3xl pointer-events-none"/>}

            <div className="relative max-w-[1500px] mx-auto">
              {/* Header */}
              <div className="grid lg:grid-cols-12 gap-8 mb-10">
                <div className="lg:col-span-6">
                  <div className="text-[11px] uppercase tracking-[0.28em] font-semibold mb-3 text-[var(--orange)]">
                    Sector {String(idx + 1).padStart(2, '0')}
                  </div>
                  <h2 className="font-display text-[clamp(30px,4vw,56px)] leading-[1.02] font-bold tracking-tight">
                    {sector.title}
                  </h2>
                </div>
                <div className="lg:col-span-6 flex items-end">
                  <p className={`text-[16px] md:text-[17px] leading-[1.85] ${isDark ? 'text-white/80' : 'text-[var(--text-mid)]'}`}>
                    {sector.blurb}
                  </p>
                </div>
              </div>

              {/* Rotating logo carousel — single row, 5-6 visible */}
              <div className="mb-12">
                <LogoCarousel logos={sector.logos} isDark={isDark} />
              </div>

              {/* Project photo gallery */}
              {sector.photos.length > 0 && (
                <div>
                  <div className={`text-[11px] uppercase tracking-[0.22em] font-semibold mb-5 ${isDark ? 'text-white/50' : 'text-[var(--text-light)]'}`}>
                    Project Gallery
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                    {sector.photos.map((p, j) => (
                      <div
                        key={j}
                        className="group relative aspect-[4/3] rounded-xl overflow-hidden border border-white/10 reveal"
                        style={{ transitionDelay: `${j * 40}ms` }}
                        data-testid={`project-photo-${sector.id}-${j}`}
                      >
                        <img
                          src={p.src}
                          alt={p.caption}
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                          loading="lazy"
                          onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"/>
                        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                          <p className="text-white text-[11px] font-medium leading-tight">{p.caption}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        );
      })}

      {/* CTA */}
      <section className="px-6 md:px-10 lg:px-14 pb-6 pt-0 bg-[var(--cream)]">
        <div className="max-w-[1500px] mx-auto relative overflow-hidden rounded-3xl bg-[var(--ink)] text-white p-10 md:p-16">
          <div className="absolute inset-0 grid-bg-dark opacity-50"/>
          <div className="absolute -top-32 -right-32 w-[400px] h-[400px] rounded-full bg-[var(--orange)]/15 blur-3xl"/>
          <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <h2 className="font-display text-[clamp(28px,3.6vw,46px)] leading-[1.05] font-bold max-w-3xl">
              Have a project in <span className="font-serif-it text-[var(--orange)]">mind?</span>
            </h2>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[var(--orange)] hover:bg-[var(--orange-soft)] text-white px-7 py-4 rounded-full font-medium transition-colors" data-testid="our-work-cta">
              Request a Proposal <ArrowUpRight className="w-4 h-4"/>
            </Link>
          </div>
        </div>
      </section>

      {/* Feedback CTA */}
      <section className="px-6 md:px-10 lg:px-14 pb-20 pt-0 bg-[var(--cream)]">
        <div className="max-w-[1500px] mx-auto relative overflow-hidden rounded-3xl bg-[var(--orange)] text-white p-10 md:p-16">
          <div className="absolute inset-0 noise"/>
          <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <h2 className="font-display text-[clamp(28px,3.6vw,46px)] leading-[1.05] font-bold max-w-3xl" style={{color:'#fff'}}>
              Already worked with us?
            </h2>
            <button onClick={() => setCsatOpen(true)} className="inline-flex items-center gap-2 bg-[var(--ink)] hover:bg-black text-white px-7 py-4 rounded-full font-medium transition-colors" data-testid="feedback-cta">
              Give Feedback <ArrowUpRight className="w-4 h-4"/>
            </button>
          </div>
        </div>
      </section>
      <CSatSurveyModal open={csatOpen} onClose={() => setCsatOpen(false)}/>
    </main>
  );
}
